<div class="admin-shell h-screen overflow-hidden" [class.admin-shell--collapsed]="!sidebarOpen() && !isMobile()">
  <div class="shell__brand flex items-center overflow-hidden">
    <div class="shell__brand-tile flex shrink-0 items-center justify-center">
      <img src="assets/stsl-icon.png" alt="GoTo Secure" width="20" height="20" />
    </div>
    @if (sidebarOpen() || isMobile()) {
      <span class="shell__wordmark overflow-hidden whitespace-nowrap">GoTo Secure</span>
    }
  </div>

  <mat-toolbar class="topbar relative flex items-center">
    <span class="topbar__title whitespace-nowrap">{{ tenantService.appHeaderAlias() }}</span>
    <span class="flex-1"></span>
    @let activeTenantCode = currentTenantCode();

    @if (canSwitchTenants()) {
      <button
        type="button"
        class="topbar__pill flex cursor-pointer items-center whitespace-nowrap"
        cdkOverlayOrigin
        #tenantTrigger="cdkOverlayOrigin"
        [class.topbar__pill--open]="openMenu() === 'tenant'"
        (click)="toggleMenu('tenant')"
        aria-label="Switch tenant">
        <mat-icon class="topbar__pill-icon">apartment</mat-icon>
        <span>{{ currentTenantDisplayName() }}</span>
        <mat-icon class="topbar__pill-chevron">expand_more</mat-icon>
      </button>
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="tenantTrigger"
        [cdkConnectedOverlayOpen]="openMenu() === 'tenant'"
        [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
        [cdkConnectedOverlayPositions]="dropdownPositions"
        (backdropClick)="closeMenus()"
        (detach)="closeMenus()">
        <div class="topbar__dropdown relative" role="menu" (mouseleave)="clearSubmenu()">
          @if (currentTenant(); as selectedTenant) {
            <div class="topbar__dropdown-header">
              <div class="topbar__dropdown-header-name block overflow-hidden text-ellipsis whitespace-nowrap">{{ selectedTenant.name }}</div>
              <div class="topbar__dropdown-header-sub block">{{ activeTenantCode }}</div>
            </div>
          }

          <div
            class="relative"
            (mouseenter)="openSubmenu.set('tenant')"
            (focusin)="openSubmenu.set('tenant')">
            <button type="button" class="topbar__dropdown-item" [class.topbar__dropdown-item--active]="openSubmenu() === 'tenant'">
              <mat-icon class="topbar__dropdown-icon">swap_horiz</mat-icon>
              <span class="topbar__dropdown-label min-w-0 flex-1">Switch tenant</span>
              <mat-icon class="topbar__dropdown-chevron">chevron_left</mat-icon>
            </button>
            @if (openSubmenu() === 'tenant') {
              <div class="topbar__flyout" role="menu">
                @for (availableTenant of availableTenants(); track availableTenant.id) {
                  <button
                    type="button"
                    class="topbar__dropdown-item topbar__dropdown-item--stacked"
                    [class.topbar__dropdown-item--active]="availableTenant.shortCode === activeTenantCode"
                    (click)="switchToTenant(availableTenant)">
                    <span class="topbar__dropdown-label min-w-0 flex-1">
                      <span>{{ availableTenant.name || 'loading...' }}</span>
                      @if (availableTenant.shortCode) {
                        <span class="topbar__dropdown-subtext block">{{ availableTenant.shortCode }}</span>
                      }
                    </span>
                    @if (availableTenant.shortCode === activeTenantCode) {
                      <mat-icon class="topbar__dropdown-icon topbar__dropdown-icon--primary">done</mat-icon>
                    }
                  </button>
                }
              </div>
            }
          </div>

          @if (isSuperUser()) {
            <button type="button" class="topbar__dropdown-item" (mouseenter)="clearSubmenu()" (focusin)="clearSubmenu()" (click)="goToTenantSettings()">
              <mat-icon class="topbar__dropdown-icon">settings</mat-icon>
              <span class="topbar__dropdown-label min-w-0 flex-1">Settings</span>
            </button>
          }
        </div>
      </ng-template>
    }

    @if (inDevelopment && hasRole(UserRole.SuperUser)) {
      <button
        type="button"
        class="topbar__pill flex cursor-pointer items-center whitespace-nowrap"
        cdkOverlayOrigin
        #devToolsTrigger="cdkOverlayOrigin"
        [class.topbar__pill--open]="openMenu() === 'dev'"
        (click)="toggleMenu('dev')">
        <mat-icon class="topbar__pill-icon">wifi</mat-icon>
        <span>Dev Tools</span>
        <mat-icon class="topbar__pill-chevron">expand_more</mat-icon>
      </button>
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="devToolsTrigger"
        [cdkConnectedOverlayOpen]="openMenu() === 'dev'"
        [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
        [cdkConnectedOverlayPositions]="dropdownPositions"
        (backdropClick)="closeMenus()"
        (detach)="closeMenus()">
        <div class="topbar__dropdown relative" role="menu" (mouseleave)="clearSubmenu()">
          @if (userData?.roles?.length) {
            <div
              class="relative"
              (mouseenter)="openSubmenu.set('roles')"
              (focusin)="openSubmenu.set('roles')">
              <button type="button" class="topbar__dropdown-item" [class.topbar__dropdown-item--active]="openSubmenu() === 'roles'">
                <mat-icon class="topbar__dropdown-icon">supervised_user_circle</mat-icon>
                <span class="topbar__dropdown-label min-w-0 flex-1">Roles</span>
                <mat-icon class="topbar__dropdown-chevron">chevron_left</mat-icon>
              </button>
              @if (openSubmenu() === 'roles') {
                <div class="topbar__flyout" role="menu">
                  @for (role of userData?.roles ?? []; track role) {
                    <button type="button" class="topbar__dropdown-item" [class.topbar__dropdown-item--active]="isRoleEnabled(role)" (click)="toggleRole(role)">
                      @if (isRoleEnabled(role)) {
                        <mat-icon class="topbar__dropdown-icon topbar__dropdown-icon--primary">done</mat-icon>
                      }
                      <span class="topbar__dropdown-label min-w-0 flex-1">Role: {{ role }}</span>
                    </button>
                  }
                </div>
              }
            </div>
          }

          <div
            class="relative"
            (mouseenter)="openSubmenu.set('flags')"
            (focusin)="openSubmenu.set('flags')">
            <button type="button" class="topbar__dropdown-item" [class.topbar__dropdown-item--active]="openSubmenu() === 'flags'">
              <mat-icon class="topbar__dropdown-icon">flag</mat-icon>
              <span class="topbar__dropdown-label min-w-0 flex-1">Toggle Feature Flags</span>
              <mat-icon class="topbar__dropdown-chevron">chevron_left</mat-icon>
            </button>
            @if (openSubmenu() === 'flags') {
              <div class="topbar__flyout" role="menu">
                @for (flag of featureFlags; track flag.value) {
                  @let flagOn = isFeatureFlagSet(flag.value);
                  <button type="button" class="topbar__dropdown-item" (click)="toggleFeatureFlag(flag.value)">
                    <span class="topbar__dropdown-label min-w-0 flex-1">{{ flag.name }}</span>
                    <span class="topbar__flag-pill shrink-0" [class.topbar__flag-pill--on]="flagOn">
                      {{ flagOn ? 'ON' : 'OFF' }}
                    </span>
                  </button>
                }
              </div>
            }
          </div>
        </div>
      </ng-template>
    }

    @if (userData) {
      <button
        type="button"
        class="topbar__pill topbar__pill--user flex cursor-pointer items-center whitespace-nowrap"
        cdkOverlayOrigin
        #userTrigger="cdkOverlayOrigin"
        [class.topbar__pill--open]="openMenu() === 'user'"
        (click)="toggleMenu('user')">
        <span class="topbar__avatar grid shrink-0 place-items-center">{{ userInitials }}</span>
        <span>{{ userData.name }}</span>
        <mat-icon class="topbar__pill-chevron">expand_more</mat-icon>
      </button>
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="userTrigger"
        [cdkConnectedOverlayOpen]="openMenu() === 'user'"
        [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
        [cdkConnectedOverlayPositions]="dropdownPositions"
        (backdropClick)="closeMenus()"
        (detach)="closeMenus()">
        <div class="topbar__dropdown relative" role="menu">
          <div class="topbar__dropdown-header topbar__dropdown-header--user flex items-center">
            <span class="topbar__avatar topbar__avatar--menu grid shrink-0 place-items-center">{{ userInitials }}</span>
            <span class="flex min-w-0 flex-col">
              <span class="topbar__dropdown-header-name block overflow-hidden text-ellipsis whitespace-nowrap">{{ userData.name }}</span>
              <span class="topbar__dropdown-header-sub block">{{ userData.email }}</span>
            </span>
          </div>
          <button type="button" class="topbar__dropdown-item" (click)="logout()">
            <mat-icon class="topbar__dropdown-icon">meeting_room</mat-icon>
            <span class="topbar__dropdown-label min-w-0 flex-1">Log out</span>
          </button>
        </div>
      </ng-template>
    }
  </mat-toolbar>

  @if (shouldShowBackdrop()) {
    <div class="sidebar-backdrop" (click)="sidebarOpen.set(false)"></div>
  }

  <aside class="sidebar flex flex-col overflow-hidden"
    [class.sidebar--mobile-open]="isMobile() && sidebarOpen()"
    [class.sidebar--mobile-closed]="isMobile() && !sidebarOpen()">

    <nav class="sidebar__nav flex-1 overflow-y-auto">
      @for (section of visibleSections; track section.label) {
        <div class="sidebar__section">
          @if (sidebarOpen() || isMobile()) {
            <span class="sidebar__section-label block whitespace-nowrap">{{ section.label }}</span>
          }
          @for (item of section.items; track item.label) {
            @if (item.children) {
              <div class="sidebar__group">
                <button
                  type="button"
                  class="sidebar__item sidebar__item--parent flex w-full cursor-pointer items-center overflow-hidden whitespace-nowrap"
                  [class.sidebar__item--expanded]="isExpanded(item)"
                  (click)="toggleExpanded(item, $event)"
                  [title]="(!sidebarOpen() && !isMobile()) ? item.label : ''">
                  <mat-icon class="sidebar__icon">{{ item.icon }}</mat-icon>
                  @if (sidebarOpen() || isMobile()) {
                    <span class="sidebar__label flex-1 overflow-hidden text-left text-ellipsis">{{ item.label }}</span>
                    <mat-icon class="sidebar__chevron">{{ isExpanded(item) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                  }
                </button>
                @if (isExpanded(item) && (sidebarOpen() || isMobile())) {
                  <div class="sidebar__children">
                    @for (child of item.children; track child.route) {
                      <a
                        class="sidebar__item sidebar__item--child flex w-full cursor-pointer items-center overflow-hidden whitespace-nowrap"
                        [routerLink]="child.route"
                        routerLinkActive="sidebar__item--active"
                        [routerLinkActiveOptions]="{exact: true}">
                        <span class="sidebar__child-prefix">└</span>
                        <span class="sidebar__label flex-1 overflow-hidden text-left text-ellipsis">{{ child.label }}</span>
                      </a>
                    }
                  </div>
                }
              </div>
            } @else {
              <a
                class="sidebar__item flex w-full cursor-pointer items-center overflow-hidden whitespace-nowrap"
                [routerLink]="item.route || '.'"
                routerLinkActive="sidebar__item--active"
                [routerLinkActiveOptions]="{exact: item.route === '' || item.route === '.'}"
                [title]="(!sidebarOpen() && !isMobile()) ? item.label : ''">
                <mat-icon class="sidebar__icon">{{ item.icon }}</mat-icon>
                @if (sidebarOpen() || isMobile()) {
                  <span class="sidebar__label flex-1 overflow-hidden text-left text-ellipsis">{{ item.label }}</span>
                }
              </a>
            }
          }
        </div>
      }
    </nav>

    <div class="sidebar__footer flex items-center">
      <button class="sidebar__item sidebar__item--footer flex w-full cursor-pointer items-center overflow-hidden whitespace-nowrap" (click)="showAppInfo()" [title]="(!sidebarOpen() && !isMobile()) ? 'About' : ''">
        <mat-icon class="sidebar__icon">info</mat-icon>
        @if (sidebarOpen() || isMobile()) {
          <span class="sidebar__label flex-1 overflow-hidden text-left text-ellipsis">About</span>
        }
      </button>
      @if (!isMobile()) {
        <button class="sidebar__collapse-btn ml-auto flex shrink-0 cursor-pointer items-center justify-center" (click)="toggleSidebar()" [attr.aria-label]="sidebarOpen() ? 'Collapse sidebar' : 'Expand sidebar'">
          <mat-icon>{{ sidebarOpen() ? 'chevron_left' : 'chevron_right' }}</mat-icon>
        </button>
      }
    </div>
  </aside>

  @if (isMobile() && !sidebarOpen()) {
    <button class="sidebar__mobile-open-btn flex cursor-pointer items-center justify-center" (click)="sidebarOpen.set(true)" aria-label="Open menu">
      <mat-icon>keyboard_double_arrow_right</mat-icon>
    </button>
  }

  <main class="admin-shell__content flex overflow-auto">
    <router-outlet class="hidden"></router-outlet>
  </main>

</div>
